export default __webpack_public_path__ + "static/media/643.c678a9de.jpg";